import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { AdminSubscriptionTableRow, formatAddress } from '../utils'

interface Props {
  open: boolean
  onClose: () => void
  row: AdminSubscriptionTableRow
}

export const CustomerContactModal: React.FC<Props> = ({
  open,
  onClose,
  row,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{`${row.customerName} contact details`}</DialogTitle>
    <DialogContent dividers>
      <Stack spacing={1.5}>
        <div>
          <Typography variant="caption" color="text.secondary">
            Address
          </Typography>
          <Typography variant="body2">{formatAddress(row)}</Typography>
        </div>
        <div>
          <Typography variant="caption" color="text.secondary">
            Phone Number
          </Typography>
          <Typography variant="body2">{row.phoneNumber || '—'}</Typography>
        </div>
        <div>
          <Typography variant="caption" color="text.secondary">
            Email
          </Typography>
          <Typography variant="body2">{row.email || '—'}</Typography>
        </div>
        <div>
          <Typography variant="caption" color="text.secondary">
            Customer Profile
          </Typography>
          <Typography variant="body2">
            {`Customer #${row.customerProfileId}`}
          </Typography>
        </div>
      </Stack>
    </DialogContent>
  </Dialog>
)
